export enum MediaTypeEnum {
  IMAGE = 1,
  VIDEO = 2,
  AUDIO = 3,
  DOC = 4
}
